module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1023-dd36e6949672b0fc29dd64cf156d62dd.png";